<template>
  <main class="auth-experience">
    <router-link to="/" class="auth-brand" aria-label="Voltar para a página inicial da Sanvault">
      <img src="../../assets/images/home/favicon.png" alt="">
      <span>Sanvault</span>
    </router-link>

    <section class="auth-value-panel">
      <div class="auth-value-panel__content">
        <span class="auth-kicker">Governança de gravações + inteligência operacional</span>
        <h1>Suas conversas organizadas e prontas para trabalhar.</h1>
        <p>
          Acesse as gravações da sua operação, acompanhe métricas e encontre rapidamente
          o contexto de cada chamada.
        </p>
        <div class="auth-value-list">
          <span><i class="ph ph-magnifying-glass"></i> Busca pelo conteúdo falado</span>
          <span><i class="ph ph-chart-line-up"></i> Métricas claras da operação</span>
          <span><i class="ph ph-shield-check"></i> Histórico centralizado e protegido</span>
        </div>
      </div>
    </section>

    <section class="auth-form-panel auth-form-panel--login" aria-label="Acesso à plataforma">
      <LoginForm />
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import LoginForm from "../../components/Authentication/LoginForm.vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    LoginForm,
  },
});
</script>
